import { Response } from 'miragejs';

export function paginatedResponse(routeHandler, collection, request) {
  const models = collection.models;

  const response = routeHandler.serializerOrRegistry.serialize(collection, request);
  response.meta = {
    total: models.length,
  };

  if (request.queryParams['page[offset]']) {
    response.data.splice(0, request.queryParams['page[offset]']);
  }

  if (request.queryParams['page[limit]']) {
    response.data.splice(request.queryParams['page[limit]'], response.data.length);
  }

  return new Response(200, {}, response);
}
